import * as ngCore from '@angular/core'

import * as tag from '../../../../../tag'

/** TODO:  */
@ngCore.Component({
  imports: [tag.Component],
  selector: 'atn-value-list',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** TODO: */
  public readonly valueSg = ngCore.input.required<readonly unknown[]>({
    alias: 'value',
  })

  /** TODO:  */
  public readonly hasMoreThenOneElSg = ngCore.computed(
    (value = this.valueSg()) => value.length > 1,
  )

  /**
   * First element, converted to string, as we are passing it to
   * {@link tag.Component ds-tag} component which expects string input
   */
  public readonly firstElValueSg = ngCore.computed((value = this.valueSg()) =>
    value[0]?.toString(),
  )
}
